import * as React from "react";
function MdIcon() {
    return React.createElement("path", { d: "M4.4165 18.5832V7.41656H7.88763V8.49989H5.49982V17.4999H14.4998V8.49989H12.112V7.41658H15.5831V18.5832H4.4165ZM9.45817 12.7915V3.78674L8.06232 5.1826L7.2883 4.41658L9.99982 1.70508L12.7113 4.41658L11.9373 5.1826L10.5415 3.78674V12.7915H9.45817Z", fill: "currentColor" });
}
export default MdIcon;
//# sourceMappingURL=Md.js.map